import routesData from '@/src/routesData.local.json';
import { Metadata } from 'next';
import getOption from './getOption';

export function getPageData(slug: string) {
  const page = routesData[slug as keyof typeof routesData];
  if (page) {
    return { ...page, slug };
  }
  return false;
}

export function getPageMetaData(slug: string, locale: string): Metadata {
  const page = getPageData(slug) as any;
  const ats = process.env.NEXT_PUBLIC_TITLE ?? 'ATS';
  const meta = {
    title: ats,
    openGraph: {
      images: [getOption('URL') + '/ats.png'],
    }
  } as Metadata;
  if (page) {
    meta.title = (page['meta-title-' + locale] || page['title-' + locale] || page['name-' + locale] || slug) + ' - ' + ats;
    const description = page['meta-description-' + locale] || page['description-' + locale];
    if (description) {
      meta.description = description;
    }
  }
  return meta;
}
